module.exports = __webpack_public_path__ + "fe28383df91ea2afd18b55f73dc33e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = 617
// module chunks = 0